import { CxEvent } from '@spartacus/core';

export class FbqGgCartPageEvent extends CxEvent {
  event?: string;
}
